module.exports = __webpack_public_path__ + "img/picture-1.8295e572.png";